import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { ReduxState } from '../../store';
import { hideFlashMessage } from '../../store/session';
import { useTranslation } from '../Translate';

type Props = {
  timeout?: number;
};

export default function FlashMessage({ timeout = 5000 }: Props) {
  const dispatch = useDispatch();
  const flashMessage = useSelector((state: ReduxState) => state.session.flashMessage);
  const { t } = useTranslation();

  useEffect(() => {
    if (flashMessage.show) {
      setTimeout(() => {
        dispatch(hideFlashMessage());
      }, timeout);
    }
  }, [dispatch, flashMessage, timeout]);

  const { show, className } = flashMessage;
  const message = t(flashMessage.message, { default: flashMessage.message });

  return (
    <div className={`flash-container ${show ? 'flash-container--open' : ''}`}>
      <div className={`flash ${className || ''}`}>{message}</div>
      <button className="close m-0 p-0" onClick={() => dispatch(hideFlashMessage())} type="button">
        <i className="icon icon-close" />
      </button>
    </div>
  );
}
